<template>
<section class="ml-0 pl-0 info w-100 col-sm-12">
  <main
  :class="fullView ? 'main' : 'col-12'">

  <LoadingSpinner v-if="loading" />
  <div
  :class="fullView ? 'pt-5' : ''" v-else>

      <div v-if="(adminTeam() || !permissionFront()) && opportunity.link.link_status_id == 8 && opportunity.link.link_status_reason_id == 34"
      class="p-2 m-3 rounded  bg-danger" >
        <small class="text-white">{{$t('lang.refuse.refusewarning')}}
            </small>
    </div>
      <div v-if="(adminTeam() || !permissionFront()) && opportunity.link.link_status_id == 8 && opportunity.link.link_status_reason_id == 35"
      class="p-2 m-3 rounded  bg-warning" >
        <small class="text-white">{{$t('lang.refuse.absent')}}
            </small>
    </div>

  <RefuseOpportunity
  v-if="refuse && opportunity.link.link_status_reason_id != 35 && opportunity.link.link_status_reason_id != 34"
  @cancel="closeRefuse()"
  @refused="refused()"
  ></RefuseOpportunity>



  <div class="contentCenter" >

      <div  v-if="!refuse"
      class="row animated fadeIn fast mx-0">


      <div
          class="col-md-4">



      <OportunityTopArea
         v-if="permissionFront()"
        :business="opportunity.business"
        :businessContacts="opportunity.business_contacts"
        :status="opportunity.status"
        :link="opportunity.link"
        :events="opportunity.events"
        :unlocked="opportunity.unlocked"
        @doNotContactBusiness="doNotContactBusiness($event)"
        @unsuscribeBusiness="unsuscribeBusiness($event)"
        @deleteBusiness="deleteBusiness($event)"
        @positiveBusiness="positiveBusiness($event)"
        @negativeBusiness="negativeBusiness($event)"
        @unlockContacts="unlockContacts($event)"
        @reloadOp="reloadOp($event)"
        @reloadTasks="reloadTasks($event)"
      />

  <div class="form-group" v-if="currentUser.role_id == 1">
    <div class="row">
      <div class="col-12 mb-2">
        <h6  class="col-form-label">Link Event to this Opportunity</h6>
      </div>
      <div class="col-12">
        <input
          type="text"
          class="form-control float-left w-auto"
          v-model="linkIdToAttach"
        />
        <button @click="attachEventToThisOpportunity()" :disabled="!linkIdToAttach" class="btn btn-primary  float-left ml-2">Add</button>
      </div>
    </div>
  </div>
           <div class="mt-4 card p-2 rounded " v-if="permissionFront()">
              <h6 class="mb-1">{{$t('lang.column.owner')}} OliverList</h6>
              <small>{{ opportunity.link.owner_name }} ({{ opportunity.link.cn_email }})</small>
              <span v-if="isBdrUser && clientStatusIsVisible">
                {{$t('lang.column.client') }} {{ $t('lang.column.status').toLowerCase() }}:
                <span  :class="{'text-success': clientStatus, 'text-danger': !clientStatus}">{{ clientStatusText }}</span>
              </span>

              <div class="my-1" v-if="opportunity.link.calendar_link">
                <small><a target="_blank" :href="opportunity.link.calendar_link" class="text-primary cursor-pointer">
                <i class="icon-calendar mr-1"></i>Calendar</a>
                </small>
              </div>
               <div class="my-1" v-if="opportunity.link.id && opportunity.link.account_id && onlySales()" >
               <small>
                      <a
                        target="_blank"
                        class="text-primary cursor-pointer"
                        :href="'/mycalendar/' + opportunity.link.account_id + '/' + getLinkId() + '/' + opportunity.link.campaign_hash"
                        ><i class="icon-calendar mr-1"></i> https://app.oliverlist.com/mycalendar/{{
                          opportunity.link.id}}
                        </a>
                    </small>
              </div>
              <div class="my-1" v-if="opportunity.link.landing_link">
                <small><a target="_blank" :href="opportunity.link.landing_link" class="text-primary cursor-pointer">
                <i class="icon-chrome mr-1"></i>Landing page</a>
                </small>
              </div>

              <h6 class="mb-1 mt-3">{{$t('lang.column.campaign')}}</h6>
              <small>{{ opportunity.link.campaign_name }}</small>
            </div>
            <div class="mt-4 card p-2 rounded " v-else>
              <h6 class="mb-1">{{$t('lang.column.owner')}}</h6>
              <small>{{ opportunity.link.owner_name }} ({{ opportunity.link.cn_email }})</small>
            </div>
            <div class="mt-4 card p-2 rounded" v-if="opportunity.link.target_id && hasPermissions('AgencyBilling')">
              <h6 class="mb-1">{{$t('lang.label.order')}}</h6>
              <small>
                <a
                      class="text-primary"
                      target="_blank"
                      :href="'/orders/' + opportunity.link.target_id"
                      >{{ opportunity.link.target_name }}
                    </a>
              </small>
            </div>

          <Tasks
          v-if="permissionFront()"
          :link="opportunity"
          @pendingTasks="pendingTasks($event)"
          :key="tasksKey"
          />


          <OpportunityContact
            :business="opportunity.business"
            :businessContacts="opportunity.business_contacts"
            :link="opportunity.link"
            :status="opportunity.status"
            :unlocked="opportunity.unlocked"
            @unlockContacts="unlockContacts($event)"
            @changeBusinessContactStatusByLinkId="changeBusinessContactStatusByLinkId($event)"
            @unsubscribeContact="unsubscribeContact($event)"
          />

      <button class="mt-4 btn btn-outline-primary w-100  text-center"
      :disabled="opportunity.link.activerefuse == '1' || !loadEvent"
      v-if="!hasPermissions('adminClients') && (adminTeam() || !permissionFront()) &&
        !(opportunity.link.link_status_reason_id == 34 ||
        opportunity.link.link_status_reason_id == 35) "
      @click="refuse=true">
        <Tooltip
        class="text-center w-100"
        :text="(opportunity.link.activerefuse == '1') ? $t('lang.opportunities.refuse') : ''"
        :width="'auto'"
        >
          {{$t('lang.refuse.button')}}
        </Tooltip>
      </button>

      <button class="mt-4 btn btn-outline-primary w-100  text-center"
      :disabled="opportunity.link.activeabsent == '1'"
      v-if="!hasPermissions('adminClients') && (adminTeam() || !permissionFront()) &&
        !(opportunity.link.link_status_reason_id == 34 ||
        opportunity.link.link_status_reason_id == 35) "
      @click="openModal('absent')">
        <Tooltip
          class="text-center w-100"
          :text="(opportunity.link.activeabsent == '1') ? $t('lang.opportunities.absent') : ''"
          :width="'auto'"
          >
          {{$t('lang.refuse.absent')}}
        </Tooltip>
      </button>

     <modal name="absent" class="modal-preview p-4" :resizable="true"
            height="auto" width="50%" :scrollable="true" :max-width="400">
            <div class="p-4 text-center">
              <h2>{{$t('lang.label.attention')}}</h2>
              <p>{{$t('lang.refuse.callplease')}}</p>
                <div class="card m-4 text-center p-4">
                  <h5 class="text-primary">{{questions.name}}</h5>
                  <div v-for="q in questions.questions_and_answers">
                     <h5 class="text-primary">{{q.question}}: {{q.answer}}</h5>
                  </div>
                  <div>
                  </div>
                  <div>
                  <div>

                  <input  type="checkbox" class="mr-2 cursor-pointer" value="true" v-model="notcall" /><small class="mr-3 icantcall">{{$t('lang.refuse.notcall')}}</small>
                  </div>
                  </div>
                </div>
                <div>
                <button class="btn btn-primary"
                  :disabled="!validateCall()"
                  v-if="(adminTeam() || !permissionFront()) &&
                    !(opportunity.link.link_status_reason_id == 34 ||
                    opportunity.link.link_status_reason_id == 35) "
                  @click="absentContact()">{{$t('lang.button.ok')}}
                </button>
                <button class="ml-4 btn btn-danger"
                  @click="closeModal('absent')">{{$t('lang.button.cancel')}}
                </button>
                </div>
            </div>
      </modal>

    <button class="mt-4 btn btn-outline-primary w-100"
    v-if="(adminTeam() || !permissionFront()) && (opportunity.link.link_status_reason_id == 34
      ||  opportunity.link.link_status_reason_id == 35)"
    @click="valide()">{{$t('lang.label.setasvalidopportunity')}}</button>

          </div>
          <div
          class="col-md-8">
            <div class="card comments-activity-card" v-if="permissionFront()">
              <CommentsActivityTabs   />
              <div class="tab-content itemsOliver activity" id="pills-tabContent">
                <CommentsAction
                  :linkId="opportunity.link.id"
                  @createComment="opportunity.timelinePassed.unshift($event)"
                />
                <EmailAction
                  :businessContacts="opportunity.business_contacts"
                  :linkId="opportunity.link.id"
                  :campaignId="opportunity.link.campaign_id"
                  @addEmail="opportunity.timelinePassed.unshift($event)"
                />
                <ActivityAction :linkId="opportunity.link.id" />



              </div>
            </div>

            <TimelineInfo
              :campaignTokens="opportunity.campaignTokens"
              :timelineComming="opportunity.timelineComming"
              :timelinePassed="opportunity.timelinePassed"
              :timelineRecent="opportunity.timelineRecent"
              :emails="opportunity.emails"
              :status="opportunity.status"
              :id="opportunity.timelinePassed.length"
              :business="opportunity.business"
              @phone="setPhone($phone)"
            />

            <span class="w-100 text-center mt-3 bg-secondary p-2  text-white" v-if="opportunity.timelinePassed.length == 0">
            {{ $t('lang.refuse.noactivity') }}
            </span>
          </div>

      </div>

      </div>
      </div>
      </main>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { businessesService, calendlyService, opportunitiesService, businessContactsService } from "@/_services";
import OportunityTopArea from "@/components/Common/OportunityTopArea.vue";
import RefuseOpportunity from "@/components/Opportunities/RefuseOpportunity.vue";

import ContactEdition from "@/components/Common/ContactEdition.vue";
import ActivityDemoLinksTabs from "@/components/Opportunities/SingleOpportunity/ActivityDemoLinksTabs.vue";
import ActivityInfo from "@/components/Opportunities/SingleOpportunity/ActivityInfo.vue";
import DemoLinksInfo from "@/components/Opportunities/SingleOpportunity/DemoLinksInfo.vue";
import TimelineInfo from "@/components/Opportunities/SingleOpportunity/TimelineInfo.vue";
import Tasks from "@/components/Opportunities/SingleOpportunity/Tasks.vue";
import CommentsActivityTabs from "@/components/Opportunities/SingleOpportunity/CommentsActivityTabs.vue";
import ActivityAction from "@/components/Opportunities/SingleOpportunity/ActivityAction.vue";
import CommentsAction from "@/components/Opportunities/SingleOpportunity/CommentsAction.vue";
import EmailAction from "@/components/Opportunities/SingleOpportunity/EmailAction.vue";
import OpportunityContact from "@/components/Common/OpportunityContact.vue";
import QualificationButtons from "@/components/Opportunities/SingleOpportunity/QualificationButtons.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Tooltip from "@/components/Common/Tooltip.vue";


export default {
  data() {
    return {
      clientStatus: false,
      contactEdition: false,
      fullView: false,
      myteam:[],
      refuse:false,
      eventid:false,
      questions:false,
      notcall:false,
      tasksKey: 0,
      linkIdToAttach:""
    };
  },

  components: {
    OportunityTopArea,
    ContactEdition,
    LoadingSpinner,
    OpportunityContact,
    ActivityDemoLinksTabs,
    ActivityInfo,
    DemoLinksInfo,
    TimelineInfo,
    CommentsActivityTabs,
    ActivityAction,
    CommentsAction,
    QualificationButtons,
    EmailAction,
    RefuseOpportunity,
    Tasks,
    Tooltip
  },

  props: {
    emails: Object,
    opportunity_id: Number
  },

  computed: {
    ...mapState({
      isMenuCollapse: state => state.sidebar.isNavOpen,
      loading: state => state.opportunities.loadingOpportunity,
      opportunity: state => state.opportunities.selected.data,
      opportunities: state => state.opportunities.all.data,
      currentUser: (state) => state.authentication.user,
      loadEvent: state => state.opportunities.loadEvent,
      
    }),
    clientStatusIsVisible(){
      const clientStatusId = this.opportunity.link.client_status_id
      const statuses = ['4', '5', '7', '8']
      return statuses.includes(clientStatusId)
    },
    clientStatusText(){
        const clientStatusId = this.opportunity.link.client_status_id
        const inactive = ['5', '7', '8']

        if(!inactive.includes(clientStatusId)) {
          this.clientStatus = true
          return this.$t('lang.label.active')
        } else {
          this.clientStatus = false
          return this.$t('lang.label.inactive')
        }
    },
    isBdrUser() {
      const user = this.$store.state.authentication.user
      return user.team_role_id == 2 && user.role_id == 2;
    },
  },

  created(){
    let opid;
    opid = this.opportunity_id
    this.fullView = false
    this.getOpportunityById({ id: opid });
    this.disabledEsc();
  },

  methods: {


    ...mapActions("opportunities", {
      getAll: "getAll",
      getOpportunityById: "getOpportunityById",
      reloadOpportunity: "reloadOpportunity",
      getPriorityOpportunity: "getPriority",
      resetPriorityOpportunity: "resetPriority",
      startLoading: "startLoading",
      finishLoading: "finishLoading",
      changeOpportunityStatus: "changeOpportunityStatus",
      setTasks: "setTasks"
    }),

    ...mapActions("headertopbar", {
        setCurrentRoute:"setRoute",
        setCurrentRouteChild:"setRouteChild"
    }),
    attachEventToThisOpportunity(){
      opportunitiesService.attachEventToThisOpportunity(this.linkIdToAttach,this.opportunity_id).then((result) => {
            this.linkIdToAttach = "";
          if(result == "OK"){
             this.reloadOpportunity({ headerTab: "NOTHING", link_id: this.opportunity_id });
          }
        })
    },
    validateCall(){
        return this.notcall
    },
    hasPermissions(perm){
      return this.$store.getters['authentication/hasPermissions'](perm)
    },
    openModal(name) {

      if(this.opportunity !== undefined  && this.opportunity.timelinePassed !== undefined){
        if(!this.questions){
          this.opportunity.timelinePassed.forEach((item,key) => {
            if(item.event_id == 3 && !this.eventid){
              this.eventid = item.comment
              calendlyService.getEvent(item.comment).then((result) => {
                  this.questions = result.invitees[0]
              })
            }
          })
        }
        this.$modal.show(name);
      }


    },
    closeModal(name) {
      this.$modal.hide(name);
    },
    permissionFront(){
      return (this.currentUser.team_role_id == undefined || this.currentUser.team_role_id != 3)
    },
    adminTeam(){
      return (this.currentUser.team_role_id != undefined && this.currentUser.team_role_id == 2)
    },
    onlySales(){
      return (this.currentUser.team_role_id !== undefined && this.currentUser.role_id == 3)
    },
    reloadOp(){
      this.reloadOpportunity({ headerTab: "NOTHING", link_id: this.opportunity_id });
    },
    reloadTasks(){
      this.tasksKey++;
    },
    absentContact(){
      this.$swal({
        type: "warning",
        title: this.$t('lang.label.areyousure'),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t('lang.button.ok'),
        cancelButtonText: this.$t('lang.button.cancel')
      }).then(result => {
        if(result.value){
         this.startLoading();
         opportunitiesService
            .changeStatus(8,this.opportunity.link.id,35)
            .then(opportunity => {
              this.opportunity.link.link_status_id = 8
              this.opportunity.link.link_status_reason_id = 35
              this.finishLoading();
              this.$forceUpdate();
            });
        }
        this.closeModal('absent')
      });
    },
    closeRefuse(){
      this.refuse=false
    },
    openRefuse(){
      this.refuse=true
    },
    refused(){
              this.opportunity.link.link_status_id = 8
              this.opportunity.link.link_status_reason_id = 34
              this.closeRefuse()
    },

    disabledEsc(){
      document.addEventListener('keydown', function(e){
            if((e.key=='Escape'||e.key=='Esc'||e.keyCode==27) && (e.target.nodeName=='BODY')){
                e.preventDefault();
               e.stopPropagation();
                return false;
            }
        });
        document.onkeydown = function(e){
          if(e.keyCode === 27){
              e.preventDefault();
               e.stopPropagation();
              return false;
          }
      };
    },

    doNotContactBusiness(qualificationOptions) {
      this.$swal({
        type: "warning",
        title: this.$t('lang.label.areyousure'),
        text: this.$t('lang.label.donotcontactthisbusiness'),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t('lang.label.yesdonotcontactthem'),
        cancelButtonText: this.$t('lang.button.cancel')
      }).then(result => {

      });
    },


    deleteBusiness(qualificationOptions) {
      this.$swal({
        type: "warning",
        title: this.$t('lang.label.areyousure'),
        text: this.$t('lang.label.youaregoingtoclaimthisopportunity'),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t('lang.label.yesclaimthisopportunity'),
        cancelButtonText: this.$t('lang.button.cancel')
      }).then(result => {
        if (result.value) {
          this.startLoading();
          opportunitiesService
            .changeStatus(11,qualificationOptions.linkId)
            .then(opportunity => {
              this.getAll({currentPage:"1", cantPerPage: "10", searchFilter: ""});
              this.$forceUpdate();
            });
        }
      });
    },

    valide() {
      this.$swal({
        type: "success",
        title: this.$t('lang.label.areyousure'),
        text: this.$t('lang.label.setasvalidopportunity'),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t('lang.button.yes'),
        cancelButtonText: this.$t('lang.button.cancel')
      }).then(result => {
          if(result.value){
          let linkStatusReasonId = this.adminTeam() && this.opportunity.link.link_status_reason_id == 35 ? 38 : null;
          //this.startLoading();
          opportunitiesService
          .changeStatus(
            8,
            this.opportunity_id,
            linkStatusReasonId
          )
          .then(opportunity => {
             // this.finishLoading();
            this.reloadOpportunity({ headerTab: "NOTHING", link_id: this.opportunity_id });
          });
        }
      });
    },

    positiveBusiness(qualificationOptions) {
      this.$swal({
        type: "success",
        title: this.$t('lang.label.areyousure'),
        text: this.$t('lang.label.companytakecontrol'),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t('lang.button.yes'),
        cancelButtonText: this.$t('lang.button.cancel')
      }).then(result => {
          if(result.value){
          //this.startLoading();
          this.changeOpportunityStatus({link_id : qualificationOptions.linkId, link_status_name : "Positive"});
          opportunitiesService
          .changeStatus(
            8,
            qualificationOptions.linkId,
            qualificationOptions.statusReason
          )
          .then(opportunity => {
             // this.finishLoading();
            this.reloadOpportunity({ headerTab: "NOTHING", link_id: this.opportunity_id });
          });
        }
      });
    },

    negativeBusiness(qualificationOptions) {
      this.$swal({
        type: "warning",
        title: this.$t('lang.label.letolivertakecontrol'),
        text: this.$t('lang.label.olivertakecontrol'),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t('lang.button.yes'),
        cancelButtonText: this.$t('lang.button.cancel')
      }).then(result => {
       if(result.dismiss != 'cancel'){
          opportunitiesService
          .changeStatus(
            5,
            qualificationOptions.linkId,
            qualificationOptions.statusReason,
            qualificationOptions.nextCampaignId,
            qualificationOptions.campaignDate
          )
          .then(opportunity => {
            this.getAll({currentPage:"1", cantPerPage: "10", searchFilter: ""});
            this.$forceUpdate();
          });
        }
      });
    },
    unlockContacts(qualificationOptions) {
      this.$swal({
        type: "warning",
        title: this.$t('lang.label.unlockcontactsfor'),
        text: this.$t('lang.label.byunlockingcontacts'),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t('lang.button.yes'),
        cancelButtonText: this.$t('lang.button.cancel')
      }).then(result => {
       if(result.dismiss != 'cancel'){
          opportunitiesService
          .unlockContactsOpportunity(
            qualificationOptions.linkId
          )
          .then(opportunity => {
          this.$forceUpdate();
          });
        }
      });
    },
    pendingTasks(cant){

      this.setTasks({link_id: this.opportunity_id, tasks: cant});
      return true;
      this.opportunities.list.forEach((opp,key) => {
         if(opp.link_id == this.opportunity_id){
            this.opportunities.list[key].tasks = cant
            return true
         }
      });
    },
    changeBusinessContactStatusByLinkId(options){
      this.$swal({
        type: "warning",
        title: this.$t('lang.label.areyousure'),
        text: this.$t('lang.label.thiscontactwillbeunsubscribedfromthiscampaignand'),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t('lang.button.yes'),
        cancelButtonText: this.$t('lang.button.cancel')
      }).then(result => {
       if(result.dismiss != 'cancel'){
          businessContactsService
          .changeStatusByLinkId(options.businessContactId, options.linkId, 7)
          .then(opportunity => {
            this.reloadOpportunity({ headerTab: "NOTHING", link_id: this.opportunity_id });
          });
        }
      });
    },
    unsuscribeBusiness(options){
      this.$swal({
        type: "warning",
        title: this.$t('lang.label.areyousure'),
        text: this.$t('lang.label.allcontactspresentinthisopportunitywillbeunsubscribedfromthiscampaign'),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t('lang.button.yes'),
        cancelButtonText: this.$t('lang.button.cancel')
      }).then(result => {
        if (result.value) {
         //connect to service
          this.startLoading();
          opportunitiesService
            .changeStatus(13,options.linkId)
            .then(opportunity => {
              this.getAll({currentPage:"1", cantPerPage: "10", searchFilter: ""});
              this.$forceUpdate();
            });
        }
      });
    },

    unsubscribeContact(options){
     this.$swal({
        type: "warning",
        title: this.$t('lang.label.areyousure'),
        text: this.$t('lang.label.thiscontactwillbeunsubscribedfromthiscampaign'),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t('lang.button.yes'),
        cancelButtonText: this.$t('lang.button.cancel')
      }).then(result => {
        if (result.value) {
          //connect to service
           businessContactsService
          .changeStatusContactUnsubscribe(options.businessContactId, options.linkId)
          .then(opportunity => {

            this.reloadOpportunity({ headerTab: "NOTHING", link_id: this.opportunity_id });
          });
        }
      });
    },

    lateQualifiedOpportunity(qualificationOptions) {
      this.startLoading();
      opportunitiesService
        .changeStatus(
          7,
          qualificationOptions.linkId,
          qualificationOptions.statusReason,
          qualificationOptions.nextCampaignId,
          qualificationOptions.campaignDate
        )
        .then(opportunity => {
              this.getAll({currentPage:"1", cantPerPage: "10", searchFilter: ""});
              this.reloadOpportunity({ headerTab: "NOTHING", link_id: this.opportunity_id });
        });
    },

    busyOpportunity(qualificationOptions) {
      this.startLoading();
      opportunitiesService
        .changeStatus(
          6,
          qualificationOptions.linkId,
          qualificationOptions.statusReason,
          qualificationOptions.nextCampaignId,
          qualificationOptions.campaignDate
        )
        .then(opportunity => {
          this.resetPriorityOpportunity();
          this.getPriorityOpportunity();
          this.reloadOpportunity({ headerTab: "NOTHING", link_id: this.opportunity_id });
        });
    },

    convertedOpportunity(qualificationOptions) {
      this.startLoading();
      opportunitiesService
        .changeStatus(
          9,
          qualificationOptions.linkId,
          qualificationOptions.nextCampaignId,
          qualificationOptions.campaignDate
        )
        .then(opportunity => {
              this.getAll({currentPage:"1", cantPerPage: "10", searchFilter: ""});
              this.reloadOpportunity({ headerTab: "NOTHING", link_id: this.opportunity_id });
        });
    },

    lostOpportunity(qualificationOptions) {
      this.startLoading();
      opportunitiesService
        .changeStatus(
          12,
          qualificationOptions.linkId,
          qualificationOptions.statusReason,
          qualificationOptions.nextCampaignId,
          qualificationOptions.campaignDate
        )
        .then(opportunity => {
              this.getAll({currentPage:"1", cantPerPage: "10", searchFilter: ""});
              this.reloadOpportunity({ headerTab: "NOTHING", link_id: this.opportunity_id });
        });
    },
    getLinkId(){
      let linkid = 'linkid:'
      return btoa(linkid+ this.opportunity.link.id)
    }
  }
};
</script>

<style scoped>
.icantcall::selection {
  background: none;
  background-color: none;
  cursor:pointer;
}
.icantcall {
  cursor:pointer;
}
@media(min-width:1920px){
  .contentCenter{
    width: 100%;
  }
}
@media(min-width:2560px){
  .contentCenter{
    width: 90%;
  }
}
@media(min-width:3840px){
  .contentCenter{
    width: 70%;
  }
}
</style>
